// src/hooks/use-analytics.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsConfig } from '../config/analytics.js';

// Initialize GA4
export const initializeGA = () => {
  // Load the GA4 script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsConfig.measurementId}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize the dataLayer
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;  // Make gtag globally available
  
  gtag('js', new Date());
  gtag('config', analyticsConfig.measurementId, {
    page_path: window.location.pathname,
  });
};

// Custom hook for GA4 page tracking
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', analyticsConfig.measurementId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  // Function to track custom events
  const trackEvent = (eventName, eventParams = {}) => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', eventName, eventParams);
    }
  };

  return { trackEvent };
};